<template>
  <v-card flat tile>
    <v-card-title style="height: 80px" class="py-0 my-0 title">
      <div>
        <span>个人信息</span>
        <span class="px-2">|</span>
        <span class="font-weight-light primary--text">{{ self.name }}</span>
        <v-btn
          flat
          color="primary"
          @click="goToPurseDetail"
          v-if="hasWalletPermission"
          >钱包</v-btn
        >
      </div>
      <!-- <div>
        <span class="error&#45;&#45;text" style="font-size: 14px">*如需修改个人资料，请前往人力资源部</span>
      </div>-->
    </v-card-title>
    <v-list two-line>
      <template v-for="(opt, i) in opts">
        <v-divider v-if="opt.divider" :key="i + 'divider'"></v-divider>
        <v-list-tile v-if="opt.icon || opt.title || opt.subTitle" :key="i">
          <v-list-tile-action>
            <v-icon v-text="opt.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-sub-title>{{ opt.subTitle }}</v-list-tile-sub-title>
            <v-list-tile-title :class="[opt.title ? '' : 'grey--text']">{{
              opt.title || "N/A"
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-subheader v-if="opt.subheader" :key="i + 'subheader'">{{
          opt.subheader
        }}</v-subheader>
      </template>
    </v-list>
    <v-layout justify-center>
      <v-btn @click="unBindWechatConfirm" class="primary">解除绑定</v-btn>
      <v-btn @click="getPassCardData" class="primary">同步一卡通数据</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: "personalCenterWX",
  computed: {
    self() {
      return this.$store.state.login.self;
    },
    opts() {
      return [
        { divider: true },
        {
          icon: "$vuetify.icons.person",
          title: this.self.name,
          subTitle: "用户姓名",
        },
        {
          icon: "$vuetify.icons.idCard",
          title: this.self.loginId,
          subTitle: "用户账号",
        },
        {
          icon: "$vuetify.icons.phone",
          title: this.self.phone,
          subTitle: "手机号码",
        },
        {
          icon: "$vuetify.icons.org",
          title: this.$store.getters["login/orgName"],
          subTitle: "所在单位",
        },
        {
          icon: "$vuetify.icons.email",
          title: this.self.email,
          subTitle: "电子邮箱",
        },
        {
          icon: "$vuetify.icons.group",
          title: this.self.typeName,
          subTitle: "登记类型",
        },
        /* {
          divider: true,
          subheader: '绑定分组'
        },
        ...this.self.groupList.map(g => ({
          icon: '$vuetify.icons.group',
          title: g.name,
          subTitle: g.typeList.map(t => t.description).join(',')
        })),
        {
          divider: true,
          subheader: '绑定角色'
        },
        ...this.self.roleList.map(r => ({
          icon: '$vuetify.icons.role',
          title: r.name,
          subTitle: r.description
        })), */
      ];
    },
    hasWalletPermission() {
      let permission = this.$store.state.login.permission;
      if (permission.wechat === undefined) return false;
      return permission.wechat.userWallet !== undefined;
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.$store.dispatch("login/getSelfInfo").catch((e) => {
      this.$L.error(e.message);
    });
  },
  methods: {
    goToPurseDetail() {
      this.$router.push({ name: "purseDetail_wx" });
    },
    async unBindWechatConfirm() {
      let { res, close } = await this.$L.confirm({
        title: "确认解除微信公众号绑定？",
        text: `解除绑定后已赋予的所有权限将取消。`,
      });
      if (res) {
        try {
          await this.unBindWechat();
        } catch (e) {
          this.$L.alert("error", e.message);
        }
      }
      close();
    },
    async unBindWechat() {
      this.loading = true;
      try {
        let res = await this.$store.dispatch("wx/unBindWechat");
        if (res.data.status + "" === "1") {
          this.$L.alert("success", { message: "解除绑定成功" });
          this.$store.commit("login/deleteInfo");
          this.$store.commit("login/clearInit");
          let redirectUrl =
            "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=personalCenter";
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
            redirectUrl +
            "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
        } else {
          this.$L.alert("error", {
            message: "解除绑定失败，原因:" + res.data.msg,
          });
        }
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
  },
  async getPassCardData() {
    this.loading = true;
    try {
      let res = await this.$store.dispatch("wx/unBindWechat");
      if (res.data.status + "" === "1") {
        this.$L.alert("success", { message: "解除绑定成功" });
        this.$store.commit("login/deleteInfo");
        this.$store.commit("login/clearInit");
        let redirectUrl =
          "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=personalCenter";
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
          redirectUrl +
          "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
      } else {
        this.$L.alert("error", {
          message: "解除绑定失败，原因:" + res.data.msg,
        });
      }
    } catch (e) {
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
</style>
